/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ChangeDetectorRef, ElementRef, Renderer2, NgZone, Input, Directive, Injectable } from '@angular/core';
import { TextService, ChangedEvent } from '@typescript-kit/core';
import { ValueModel } from '@typescript-kit/view';

import { BaseDirective } from './base.directive';

@Directive({
  selector: '[kitValueLabel]'
})
export class ValueLabelDirective extends BaseDirective<ValueModel> {

  constructor(
    changeDetector: ChangeDetectorRef,
    elementRef: ElementRef,
    renderer: Renderer2,
    ngZone: NgZone,
    textService: TextService
  ) {
    super(changeDetector, elementRef, renderer, ngZone, textService);
  }

  get hostClass(): string {
    return 'kit-value-label';
  }

  @Input()
  set kitValueLabel(model: ValueModel) {
    this.model = model;
  }

  get kitValueLabel(): ValueModel {
    return this.model;
  }

  protected onModelChanged(model: ValueModel) {
    super.onModelChanged(model);
    this.refreshText();
  }

  protected onModelPropertyChanged(event: ChangedEvent): void {
    super.onModelPropertyChanged(event);
    if (event.changes['key'] || event.changes['scope']) {
      this.refreshText();
    }
  }

  protected refreshText() {
    this.element.innerText = this.textService.getText(this.model.scope ? `${this.model.scope}/${this.model.key}` : this.model.key);
  }

  protected refreshTags() {
    // PREVENT PARENT FROM SETTING TAGS OF VALUE ELEMENT
  }

  protected refreshTabIndex() {
    // PREVENT PARENT FROM SETTING TAB INDEX OF VALUE ELEMENT
  }

}
